/*
 * this hook returns "light" if the current theme is light and "dark" if the
 * current theme is dark
 *
 * the color-scheme value is set in src/index.scss
 */
export function getColorScheme(): "light" | "dark" {
  return getComputedStyle(document.body).getPropertyValue("--color-scheme") === "dark"
    ? "dark"
    : "light"
}
